const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Video Image component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('adminUserViewed', ['Application', 'Authorization', 'Analyze', 'Users', 'Viewables', '$q', function (Application, Authorization, Analyze, Users, Viewables, $q) {
  return {
    restrict: 'E',
    scope: {
      suspended: '='
    },
    replace: true,
    template: require('../../templates/directives/admin-user-viewed.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var routeParameters = Application.navigation.getRouteParameters();
      self.user = Authorization.getAuthToken().user;
      self.employee = {};
      self.content = {};
      self.views = [];

      self.per_page = 20;
      self.page = 1;

      if (self.user.role !== 'admin') {
        Application.navigation.goTo('/explore');
      }

      self.goTo = function(view) {
        if (view.content_type === 'quiz') {
          Application.navigation.goTo('/edit/quizzes/' + view.content);
        }
        var link = '/host/' + view.content_type;
        if (view.content_type !== 'track' && view.content_type !== 'scorm') {
          link += 's'
        }
        if (view.content_type === 'imported_content') {
          link = '/host/imported-content';
        }
        if (view.content_type === 'presentation') {
          link = '/view/presentations';
        }
        if (self.content[view.content].contentType === 'multi_session_workshop') {
          link = '/host/multi-session-workshops';
        }
        link += '/' + view.content;
        Application.navigation.goTo(link);
      };

      self.viewsPage = function() {
        return Analyze.userViews({itemid: routeParameters.id, sort: 'created_on,-1', page: self.page, per_page: self.per_page}).$promise
      };

      self.getContent = function(views) {
        if (!views || !views.length) {
          return;
        }
        var body = {viewables: []};
        angular.forEach(views, function(item) {
          if (!item.content_type || !item.content) {
            return;
          }
          body.viewables.push({type: item.content_type, id: item.content});
        })
        if (!body.viewables || !body.viewables.length) {
          return;
        }

        Viewables.titles({}, body).$promise
        .then(function(results) {
          results.forEach(function(item) {
            self.content[item.id] = item;
          });
          self.loading = false;
        });
      };

      self.changePage = function(next) {
        if (!next) {
          if (self.page > 1) {
            self.page = self.page - 1;
          }
          self.currentViews = self.page;
          return;
        }

        self.page = self.page + 1;
        if (self.views[self.page]) {
          self.currentViews = self.page;
          return;
        }

        self.loading = true;
        self.viewsPage()
        .then(function(views) {
          if (views.length < self.per_page) {
            self.noMore = true;
          }
          self.views[self.page] = views;
          self.currentViews = self.page;
          self.getContent(views);
        });
      };

      self.initialize = function() {
        if (!routeParameters.id) {
          return;
        }
        self.loading = true;
        var userPromise = $scope.suspended ? Users.suspended({_id: routeParameters.id, fields: '_id,first_name,last_name,full_name,email'}).$promise : Users.get({subresource: routeParameters.id}).$promise;
        var viewsPromise = self.viewsPage();
        $q.all([userPromise, viewsPromise]).then(function(results) {
          self.employee = results[0];
          if ($scope.suspended && self.employee[0]) {
            self.employee = self.employee[0];
          }
          self.views[self.page] = results[1];
          self.currentViews = 1;
          self.translateData = {
            value : self.employee.first_name
          };
          if (results[1].length < self.per_page) {
            self.noMore = true;
          }
          self.getContent(results[1]);
        });
      };

      self.initialize();
    }],
    controllerAs: 'viewed'
  }
}]);
